import React, { useEffect, useState } from 'react'
import {
  Container,
  Box,
  Typography,
  Button,
  Alert,
  Paper,
  Divider
} from '@mui/material'
import {
  Block as BlockIcon,
  ExitToApp as LogoutIcon,
  Refresh as RefreshIcon
} from '@mui/icons-material'
import { useAuth } from '../hooks/useAuth'
import { useNavigate } from 'react-router-dom'

const AccessDeniedPage = () => {
  const { logout, user } = useAuth()
  const navigate = useNavigate()
  const [accessDeniedMessage, setAccessDeniedMessage] = useState('')

  useEffect(() => {
    // Get the stored access denied message
    const storedMessage = localStorage.getItem('agentflow_access_denied')
    if (storedMessage) {
      setAccessDeniedMessage(storedMessage)
      localStorage.removeItem('agentflow_access_denied') // Clean up
    }
  }, [])

  const handleLogout = async () => {
    await logout()
    navigate('/')
  }

  const handleTryAgain = () => {
    // Clear tokens and access denied message, then navigate to home
    localStorage.removeItem('agentflow_jwt')
    localStorage.removeItem('agentflow_access_denied')
    navigate('/')
  }

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center'
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            maxWidth: 600,
            width: '100%'
          }}
        >
          <Box sx={{ mb: 3 }}>
            <BlockIcon 
              color="error" 
              sx={{ fontSize: 64, mb: 2 }} 
            />
            <Typography variant="h4" color="error" gutterBottom>
              Access Denied
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          {accessDeniedMessage ? (
            <Alert severity="error" sx={{ mb: 3, textAlign: 'left' }}>
              {accessDeniedMessage}
            </Alert>
          ) : (
            <Alert severity="error" sx={{ mb: 3 }}>
              You do not have the required permissions to access this application.
            </Alert>
          )}

          {user && (
            <Box sx={{ mb: 3 }}>
              <Typography variant="body1" color="text.secondary">
                Signed in as: <strong>{user.email || user.name || 'Unknown'}</strong>
              </Typography>
              {user.roles && user.roles.length > 0 && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  Your roles: {user.roles.join(', ')}
                </Typography>
              )}
            </Box>
          )}

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="outlined"
              startIcon={<RefreshIcon />}
              onClick={handleTryAgain}
              color="primary"
            >
              Try Again
            </Button>
            <Button
              variant="contained"
              startIcon={<LogoutIcon />}
              onClick={handleLogout}
              color="error"
            >
              Sign Out
            </Button>
          </Box>

          <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid', borderColor: 'divider' }}>
            <Typography variant="body2" color="text.secondary">
              If you believe you should have access to this application, please contact your administrator.
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Required roles: <strong>AgentFlow.Admin</strong> or <strong>AgentFlow.User</strong>
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  )
}

export default AccessDeniedPage